<div class="product-page component-container component-page-container action-button-wrapper">
    <div class="bottom-action-mg">
        <div class="pr-page-wrapper">
            <div class="pr-page-component flex flex-grow">
                <custom-panel header="Opis Podstawowy SKU" [areButtons]="false" class="flex flex-grow">
                    <div fxLayout="column" panel-body>
                        <div class="pr-page-info" fxLayout="row">
                            <div class="pr-page-info-desc" fxFlex="50%" fxLayout="column" fxLayoutGap="4%">
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Nazwa SKU:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Name || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Krótka Nazwa:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Description || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Status:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Status || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Data od:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ (parseDate(product.CreatedAt) | date:'yyyy-dd-MM') || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Data do:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ "-" }}</p>
                                </div>
                            </div>
                            <div class="pr-page-info-desc" fxFlex="50%" fxLayout="column" fxLayoutGap="4%">
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">EAN:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Ean || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">CKT:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Code || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Gramatura:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Weight || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Jednostka:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.UnitOfMeasure || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Typ opakowania:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.PckgType || "-" }}</p>
                                </div>
                                <div class="pr-page-desc" fxLayout="row">
                                    <p fxFlex="32%">Dostawca:</p>
                                    <p class="bold-font semi-bold-font text-primary">{{ product.Manufacturer || "-" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </custom-panel>
            </div>
            <div class="pr-page-component flex flex-grow">
                <custom-panel header="Cechy i Charakterystyka SKU" [areButtons]="false" class="flex flex-grow">
                    <div fxLayout="column" panel-body>
                        <div fxLayout="column" fxLayoutGap="1.5%">
                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Segment:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.CategoryLevel1.Name || "-" }}</p>
                            </div>
                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Kategoria:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.CategoryLevel2.Name || "-" }}</p>
                            </div>
                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Podkategoria:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.CategoryLevel3?.Name || "-" }}</p>
                            </div>

                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Marka:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.Brand || "-" }}</p>
                            </div>
                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Podmarka:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.SubBrand || "-" }}</p>
                            </div>

                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Rodzaj marki:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.BrandKind || "-" }}</p>
                            </div>
                            <div class="pr-page-desc" fxLayout="row" fxLayoutAlign="flex-start center">
                                <p fxFlex="30%">Segment cenowy:</p>
                                <p class="bold-font semi-bold-font text-primary">{{ product.PriceSegment || "-" }}</p>
                            </div>
                        </div>
                    </div>
                </custom-panel>
            </div>

            <div class="pr-page-component flex flex-grow">
                <custom-panel header="Obecna Cena Sprzedaży" [areButtons]="true" class="flex flex-grow">
                    <div fxLayout="row" fxLayoutAlign="flex-end center" panel-actions>
                        <div *ngIf="product.Alert">
                            <mat-icon class="text-red" style="cursor: pointer;" [matTooltip]="product.Alert.Message">
                                notifications
                            </mat-icon>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="1.5%" panel-body>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p class="semi-bold-font">Obecna średnia cena sprzedaży:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="currency-suf semi-bold-font text-primary">{{ (prices.UnitSalesPriceGrossAvg | number:'.2-2') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Cena MIN:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="currency-suf semi-bold-font text-primary">{{ (prices.UnitSalesPriceGrossMin | number:'.2-2') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Cena MAX:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="currency-suf semi-bold-font text-primary">{{ (prices.UnitSalesPriceGrossMax | number:'.2-2') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Średnia cena zakupu:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="currency-suf semi-bold-font text-primary">{{ (prices.UnitPurchasePriceNetAvg | number:'.2-2') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Rabat:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="percentage-suf semi-bold-font text-primary">{{ (generalService.parseVAT(prices.DiscountAvg) | number:'.1-1') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Cena po rabacie:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="currency-suf semi-bold-font text-primary">{{ (prices.DiscountedPriceAvg | number:'.2-2') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Średnia cena konkurencji:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="currency-suf semi-bold-font text-primary">{{ (prices.CompetitorPriceAvg | number:'.2-2') || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>VAT:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="percentage-suf semi-bold-font text-primary">{{ (generalService.parseVAT(prices.VatOfSales)) || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p style="text-align: right;">Typ ceny:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="text-primary semi-bold-font">{{ prices.PrcType || "-" }}</p>
                            </div>
                        </div>
                        <div class="pr-page-price" fxLayout="row">
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="flex-start center">
                                <p>Marża:</p>
                            </div>
                            <div class="pr-page-price-wrapper" fxFlex="50%"
                                fxLayoutAlign="center center">
                                <p class="percentage-suf semi-bold-font text-primary">{{ generalService.parseVAT(prices.MarginAvg) | number:'.1-1' || "-" }}</p>
                            </div>
                        </div>
                    </div>
                </custom-panel>
            </div>

            <div class="pr-page-component flex flex-grow">
                <custom-panel
                    header="Cechy produktu"
                    [areButtons]="true"
                    class="flex flex-grow"
                    (componentSave)="editFeatures()"
                    (componentReset)="cancelFeatures()"
                    [saveDisabled]="areFeaturesLoading || isFeatureLoading || isFeaturesUpdating"
                >
                    <div fxLayout="column" fxLayoutGap="2%" panel-body>
                        <div class="set-select-option">
                            <div fxLayout="column">
                                <div class="select-field" fxLayout="column">
                                    <button
                                        mat-button aria-label="Dodaj nową cechę"
                                        fxLayout="row"
                                        fxLayoutAlign="center center"
                                        class="mv-xxs"
                                        *ngIf="!areFeaturesLoading && !isFeatureLoading"
                                        (click)="addNewFeature()"
                                    >
                                        <span>Dodaj nową cechę</span> <mat-icon>add</mat-icon>
                                    </button>
                                    <button-spinner fxLayout="row" fxLayoutAlign="center center" class="mv-xxs" [inProgress]="isFeatureLoading || areFeaturesLoading" diameter="25"></button-spinner>
                                    <div fxFlex="auto" *ngFor="let changedAttribute of changedAttributes">
                                        <mat-form-field fxFlex="auto" class="mr-xs mb-s">
                                            <mat-label>
                                                Wybrana cecha*
                                            </mat-label>
                                            <mat-select [(ngModel)]="changedAttribute.AttributeId" (ngModelChange)="changeFeature(changedAttribute)">
                                                <div *ngFor="let feature of allFeatures">
                                                    <mat-option [value]="feature.id">
                                                        {{ feature.name }}
                                                    </mat-option>
                                                </div>
                                            </mat-select>
                                            <mat-hint *ngIf='isFeatureDuplicated(changedAttribute.AttributeId)' class="text-red">Wybrane cechy nie mogą się powtarzać</mat-hint>
                                        </mat-form-field>

                                        <mat-form-field fxFlex="auto" *ngIf="getFeatureType(changedAttribute.AttributeId) === FeatureTypes.Text">
                                            <label>
                                                <input matInput placeholder="Wartość cechy*" [(ngModel)]="changedAttribute.Value">
                                            </label>
                                            <mat-hint *ngIf='changedAttribute.Value === ""' class="text-red">
                                                Wartość cechy nie może być pusta
                                            </mat-hint>
                                        </mat-form-field>

                                        <mat-form-field fxFlex="auto" *ngIf="getFeatureType(changedAttribute.AttributeId) === FeatureTypes.Select">
                                            <mat-label>
                                                Wybrana wartość*
                                            </mat-label>
                                            <mat-select [(ngModel)]="changedAttribute.Value">
                                                <div *ngFor="let value of getPossibleValues(changedAttribute.AttributeId)">
                                                    <mat-option [value]="value">
                                                        {{ value }}
                                                    </mat-option>
                                                </div>
                                            </mat-select>
                                            <mat-hint *ngIf='changedAttribute.Value === ""' class="text-red">
                                                Wartość cechy nie może być pusta
                                            </mat-hint>
                                        </mat-form-field>

                                        <div class="mt-xs" fxFlex="auto" *ngIf="getFeatureType(changedAttribute.AttributeId) === FeatureTypes.Boolean">
                                            <div fxLayout="row" fxLayoutAlign="left center">
                                                <mat-label class="mr-xxxs">
                                                    Wybrana wartość cechy:
                                                </mat-label>
                                                <p-checkbox [binary]="true" [(ngModel)]="changedAttribute.Value"></p-checkbox>
                                            </div>
                                        </div>

                                        <div class="actions" fxFlex="none" fxLayout="row">
                                            <button mat-icon-button fxFlex="none" aria-label="Skasuj cechę" class="mt-xxxs" (click)="deleteFeature(changedAttribute.Id)">
                                                <mat-icon>remove</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </custom-panel>
            </div>
        </div>

<!--        <div class="pr-page-component flex flex-grow">-->
<!--            <custom-panel header="Kontrakty cenowe" [areButtons]="false" class="flex flex-grow">-->
<!--                <div fxLayout="column" fxLayoutGap="4%" panel-body>-->
<!--                    <pr-price-contracts></pr-price-contracts>-->
<!--                </div>-->
<!--            </custom-panel>-->
<!--        </div>-->

        <div class="pr-page-component flex flex-grow">
            <custom-panel header="Powiązania produktowe" [areButtons]="false" class="flex flex-grow">
                <div fxLayout="column" panel-body>
                    <template #productLogics></template>
                </div>
            </custom-panel>
        </div>

        <div class="pr-page-component flex flex-grow">
            <custom-panel header="Ceny w placówkach" [areButtons]="false" class="flex flex-grow">
                <div fxLayout="column" panel-body>
                    <pr-new-table
                        panel-body
                        class="flex flex-grow"
                        [dataService]="dataService"
                        [columnsData]="columnsData"
                        [tableId]="tableId"
                        [canNavigate]="canNavigate"
                        [dataServiceMethod]="dataServiceMethod"
                    ></pr-new-table>
                </div>
            </custom-panel>
        </div>
    </div>
</div>

<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row"
        fxLayoutGap="1%" fxLayoutAlign="flex-end center"
    >
        <button
            type="button"
            class="upper action-button butt-back action-button-icon"
            (click)="navigationBack()"
        >
            <p class="upper">wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
    </div>
</div>
